import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Menu, X } from 'lucide-react'; // Hamburger aur Close icons
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  // Jab kisi link pe click ho toh menu band ho jaye
  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        <NavLink to="/" className="nav-logo" onClick={closeMenu}>
          VEKTRIXO <span className="logo-accent">DIGITAL</span>
        </NavLink>
        
        {/* Hamburger Icon for Mobile */}
        <div className="menu-icon" onClick={toggleMenu}>
          {isOpen ? <X size={30} /> : <Menu size={30} />}
        </div>

        {/* Desktop & Mobile Links */}
        <div className={`nav-links ${isOpen ? "nav-active" : ""}`}>
          <NavLink to="/" className={({ isActive }) => isActive ? "active-link" : ""} onClick={closeMenu}>Home</NavLink>
          <NavLink to="/services" className={({ isActive }) => isActive ? "active-link" : ""} onClick={closeMenu}>Services</NavLink>
          <NavLink to="/about" className={({ isActive }) => isActive ? "active-link" : ""} onClick={closeMenu}>About</NavLink>
          <NavLink to="/careers" className={({ isActive }) => isActive ? "active-link" : ""} onClick={closeMenu}>Careers</NavLink>
          <NavLink to="/contact" className="nav-cta" onClick={closeMenu}>Work With Us</NavLink>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;